<em-auth-wrapper>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="em-form-field">
      <mat-label>Email</mat-label>
      <input
        matInput
        type="email"
        id="email"
        placeholder="mail@example.com"
        formControlName="email"
        autocomplete="email"
        autofocus
        />
      @if (loginForm.get('email')?.hasError('required')) {
        <mat-error emError="required" />
      }
      @if (loginForm.get('email')?.hasError('email')) {
        <mat-error emError="email" />
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="em-form-field">
      <mat-label>Password</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        id="password"
        placeholder="********"
        formControlName="password"
        autocomplete="new-password"
        />
      <button
        type="button"
        mat-icon-button
        color="primary"
        matSuffix
        (click)="showPassword = !showPassword"
        >
        @if (!showPassword) {
          <mat-icon svgIcon="eye" />
        }
        @if (showPassword) {
          <mat-icon svgIcon="eye-slash" />
        }
      </button>
      @if (loginForm.get('password')?.hasError('required')) {
        <mat-error emError="required" />
      }
    </mat-form-field>

    <div class="my-2.5 md:my-5 text-center">
      <a routerLink="/reset-password" class="text-sky-500 hover:text-sky-400 font-semibold">
        Forgot password
      </a>
    </div>

    <button
      emsysButton
      appearance="primary"
      [showLoader]="loading$|async"
      class="w-full"
      >
      Sign in
      <svg class="w-6 h-6 ml-auto">
        <use xlink:href="assets/icons/symbols.svg#arrow-right"></use>
      </svg>
    </button>
  </form>

  <!--<login-with-social></login-with-social>-->

  <ng-template teleport="greet">
    <div class="flex flex-col min-h-full">
      <h1 class="text-4xl font-bold">
        Sales Portal
      </h1>

      <div class="flex items-center font-bold text-xl">
        <div class="h-[2px] w-5 bg-blue-50/25 mr-2.5"></div>
        Log In
      </div>

      <!--<div class="mt-auto">
      Don't have an account.
      <a routerLink="/register" class="font-bold">
        Sign Up
      </a>
    </div>-->
  </div>
</ng-template>
</em-auth-wrapper>
